<h1 mat-dialog-title>{{ product.name }} {{ 'PROJECT.FINANCIAL_GEN_PROD.FIN_INFO' | anessaTranslation: trigger }}</h1>
<mat-dialog-content>
  <form #genProdForm="ngForm">
    <!-- digestate price type select -->

    <div class="flex-container" *ngIf="showPriceType">
      <div class="flex-box border-shadow">
        <h3 class="compact-header-margin" anessaTranslation="PROJECT.FINANCIAL_GEN_PROD.PRICE_TYPE"></h3>
        <mat-form-field floatLabel="never">
          <mat-select
            required
            placeholder=""
            disableOptionCentering
            [(ngModel)]="product.priceType"
            name="price-type"
          >
            <ng-container *ngFor="let type of priceTypes">
              <mat-option [value]="type.value">{{ type.name | anessaTranslation: trigger}}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <ng-container *ngIf="product.priceType !== FinancialPriceType.FREE">

      <!-- price inputs -->
      <div class="flex-box border-shadow">
        <h3 class="compact-header-margin">{{ (showLabelForDigestate() ? 'PROJECT.FINANCIAL_GEN_PROD.DIG_PRICE' : 'PROJECT.FINANCIAL_GEN_PROD.INCOME_PRICE') | anessaTranslation: trigger }}</h3>
        <div class="flex-container separator-wrapper">
          <div class="flex-box"
               style="padding-left: 0;"
          >
            <app-unit-value [units]="'Currency'"
                            name="price"
                            [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                            [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                            [enableNegativeValidation]="false"
                            [(ngModel)]="product.price"
            >
            </app-unit-value>
          </div>
          <div class="separator-text">
            <div anessaTranslation="PROJECT.COMMON.PER"></div>
          </div>
          <div class="flex-box"
               style="padding-right: 0;"
          >
            <app-unit-value [units]="getUnitString()"
                            name="per"
                            [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                            [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                            [(ngModel)]="product.quantity"
            >
            </app-unit-value>
          </div>
        </div>
      </div>

      <!-- CPI input -->
      <div class="flex-container">
        <div class="flex-box border-shadow">
          <h3 class="compact-header-margin">{{ (showLabelForDigestate() ? 'PROJECT.FINANCIAL_GEN_PROD.DIG_CPI' : 'PROJECT.FINANCIAL_GEN_PROD.PROD_CPI') | anessaTranslation: trigger }}</h3>
          <app-unit-value [units]="'CPI'"
                          name="fuelcpi"
                          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                          [(ngModel)]="product.cpi"
                          [enableNegativeValidation]="false"
          ></app-unit-value>
        </div>
      </div>
    </ng-container>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="fatbuttongroup">
  <button
    mat-button
    class="btn-fat btn-green"
    type="button"
    (click)="onSaveClick()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-button
    class="btn-fat btn-red"
    type="button"
    (click)="onCancelClick()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
